import {CreateBundleFormValues} from "../reducers/create-bundle/types";
import {createBundleV2Dto} from "../create-bundle-service";
import {CreateBundleApiResponse} from "../../../../react-query-hooks/session/types/bundle/create";
import {useCreateBundleContext} from "../context/create-bundle";
import {useCreateSession, Session} from "../../../../features/sessions";
import {sessionToLegacyAdapter} from "../../editService/context/get-session/session-to-legacy.adapter";

interface HookResult {
  createBundle(values: CreateBundleFormValues): void;
  wasBundleCreated: boolean;
  isCreatingBundle: boolean;
  responseData?: Session;
}

export function useCreateBundleHook(): HookResult {
  const {dispatch} = useCreateBundleContext();
  const createSessionMutation = useCreateSession();

  const createBundle = (values: CreateBundleFormValues) => {
    createSessionMutation.mutate(createBundleV2Dto(values), {
      onSuccess(session) {
        dispatch({
          type: "go-to-cover-images-upload-form-step",
          payload: {
            apiResponse: sessionToLegacyAdapter(session) as CreateBundleApiResponse,
            formData: values,
          },
        });
      },
    });
  };

  return {
    createBundle,
    wasBundleCreated: createSessionMutation.isSuccess,
    isCreatingBundle: createSessionMutation.isPending,
    responseData: createSessionMutation.isSuccess
      ? createSessionMutation.data
      : undefined,
  };
}
